/**
 * Created by Reda on 17.08.2026
 */

RewardsConfig.Autumn26Pack = [
    { hard: 350, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
    { hard: 1200, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
    { hard: 1200, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
    { hard: 6500, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
    { hard: 6500, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
];

RewardsConfig.Autumn26LineOffer = [
    { hard: 50, energy: 50, unit: [{ code: "drfruit", stage: 4, amount: 3 }] },
    { hard: 100, energy: 150, unit: [{ code: "drfruit", stage: 4, amount: 5 }] },
    { hard: 100, energy: 150, unit: [{ code: "drfruit", stage: 4, amount: 5 }] },
    { hard: 350, energy: 450, unit: [{ code: "drfruit", stage: 4, amount: 10 }] },
    { hard: 350, energy: 450, unit: [{ code: "drfruit", stage: 4, amount: 10 }] }
];

RewardsConfig.Autumn26HeroOffer = [
    { energy: 100, unit: [{ code: "drshopchest", stage: 2, amount: 1 }] },
    { energy: 350, unit: [{ code: "drshopchest", stage: 2, amount: 2 }] },
    { energy: 350, unit: [{ code: "drshopchest", stage: 2, amount: 2 }] },
    { energy: 2000, unit: [{ code: "drshopchest", stage: 2, amount: 8 }] },
    { energy: 2000, unit: [{ code: "drshopchest", stage: 2, amount: 8 }] }
];